import { Col, Row } from "antd";

import EvaluationList from "./components/EvaluationList";

export default function PageDashboard() {
	return (
		<Row gutter={[20, 20]}>
			<Col xs={24} sm={24} md={24} lg={24} xl={24}>
				<EvaluationList />
			</Col>
		</Row>
	);
}
